import { render, staticRenderFns } from "./invoice-create.vue?vue&type=template&id=6b83707e&scoped=true"
import script from "./invoice-create.vue?vue&type=script&lang=js"
export * from "./invoice-create.vue?vue&type=script&lang=js"
import style0 from "./invoice-create.vue?vue&type=style&index=0&id=6b83707e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b83707e",
  null
  
)

export default component.exports